/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import {Box, CollapsedText} from '@tenancy.nz/design-system';
import makeNl2br from '../utils/helpers/nl2br';

function CollapsibleText({
  text = '',
  maxVisibleChars = 620,
  nl2br = true,
  ...rest
}) {
  const content = nl2br ? makeNl2br(text) : text;
  if (!text) {
    return null;
  }
  if (text.length <= maxVisibleChars) {
    return <Box>{content}</Box>;
  }
  return (
    <CollapsedText
      buttonLabel={{open: 'Read less', closed: 'Read more'}}
      collapsedLines={13}
      lineHeight={16}
      {...rest}>
      {content}
    </CollapsedText>
  );
}

CollapsibleText.propTypes = {
  text: PropTypes.string,
  maxVisibleChars: PropTypes.number,
  nl2br: PropTypes.bool,
};

export default CollapsibleText;
